export default {
      id: "pdf-file-usage",
      viewBox: "0 0 45 27",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#pdf-file",
      toString: function () {
        return this.url;
      }
    }